module.exports = __webpack_public_path__ + "static/img/commond1.9b5b824.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commond1.png
// module id = OIwJ
// module chunks = 0